import { component } from 'picoapp'

class ProductCounter {
  constructor(node, ctx) {
    // bindings
    this.onQuantityDecrease = this.onQuantityDecrease.bind(this)
    this.onQuantityIncrease = this.onQuantityIncrease.bind(this)

    // selectors
    this._node = node
    this._decrease = node.querySelector('.decrease-item')
    this._quantity = node.querySelector('.quantity-item')
    this._increase = node.querySelector('.increase-item')

    // privates
    this._ctx = ctx
    this._count = 1

    // events
    this._decrease.addEventListener('click', this.onQuantityDecrease)
    this._increase.addEventListener('click', this.onQuantityIncrease)

    this.onQuantityUpdate()

    // unmount
    return this.unmount.bind(this)
  }

  /**
   * Handle decrease.
   */
  onQuantityDecrease() {
    this._count = Math.max((parseInt(this._quantity.innerText, 10) - 1), 1)
    this.onQuantityUpdate()
  }

  /**
   * Handle quantity change.
   */
  onQuantityUpdate() {
    this._quantity.innerText = this._count
  }

  /**
   * Handle increase.
   */
  onQuantityIncrease() {
    this._count = Math.min((parseInt(this._quantity.innerText, 10) + 1), 10)
    this.onQuantityUpdate()
  }

  /**
   * Handle unmount.
   */
  unmount() {
    this._decrease.removeEventListener('click', this.onQuantityDecrease)
    this._increase.removeEventListener('click', this.onQuantityIncrease)
  }
}

export default component((node, ctx) => new ProductCounter(node, ctx))
